import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';

import { EBEPaymentMethodsName } from '../../../../../../contracts';
import newLoader from '../../../../../../assets/newLoader.json';
import { mobileSDKUtils } from '../../../../../../utils/mobile-sdk-utils';
import { StyledOverlay } from '../../../ScreenLock/style';

const BLIK_LOGO_URL = `https://media.appcharge.com/defaults/apm_logos/${EBEPaymentMethodsName.blik}_logo.png`;
const mobileSDKCheckoutStyle = mobileSDKUtils.getCheckoutStyle();

// Shown while awaiting the shopper's in-app BLIK approval. confirmBlikPayment stays
// pending until the shopper approves the push (up to 60s), declines, or it times out.
export function BlikAuthorizationScreen() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  return (
    <StyledOverlay
      backgroundColor={mobileSDKCheckoutStyle.overlayBackgroundColor}
      role="status"
      aria-live="polite"
      data-testid="blik-authorization-screen"
    >
      <img src={BLIK_LOGO_URL} alt="BLIK" style={{ height: 24, marginBottom: 16 }} />
      <Lottie animationData={newLoader} style={{ width: 64, height: 64 }} />
      <h2>{t('blikApprovalTitle')}</h2>
      <p>{t('blikApprovalSubtitle')}</p>
    </StyledOverlay>
  );
}
